// extracted by mini-css-extract-plugin
export default {"root":"UserEditPage_root__aFoSY"};